<template>
  <div id="main">
    <Navbar />
    <Slider />
    <Learning />
    <Playlist />
  </div>
</template>

<script>
import Navbar from "@/components/dashboard/Navbar";
import Slider from "@/components/dashboard/Slider";
import Learning from "@/components/dashboard/Learning";
import Playlist from "@/components/dashboard/Playlist";

export default {
  components: {Slider, Playlist, Learning, Navbar},
  data() {
    return {
      showBooking: false,
    }
  },
  mounted() {
    this.$store.dispatch('auth/getUserData');
  }
}
</script>
